import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import VueTouch from "vue-touch";
import VueWaypoint from "vue-waypoint";
import Home from "./components/Home.vue";
import ActLikeADesigner from "./components/subpages/ActLikeADesigner.vue";
import GettingPractical from "./components/subpages/GettingPractical.vue";
import VueMq from "vue-mq";

Vue.use(VueRouter);
Vue.use(VueWaypoint);
Vue.use(VueTouch);
VueTouch.config.swipe = {
  direction: "horizontal",
};
Vue.use(VueMq, {
  breakpoints: {
    "<xs": 576,
    xs: 767,
    s: 992,
    m: Infinity,
  },
});

const routes = [
  { path: "/", component: Home },
  { path: "/act-like-a-designer", component: ActLikeADesigner },
  { path: "/getting-practical", component: GettingPractical },
];

const router = new VueRouter({
  routes, // short for `routes: routes`

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

new Vue({
  router,
  el: "#app",
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js